module.exports = __webpack_public_path__ + "media/success.ddd03dcc.mp3";